import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19b6e7e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "common-color-picker" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "latest-title" }, "最近使用", -1))


const __default__ = {
  name: 'CommonPicker'
}

import { nextTick, onMounted, ref, watch } from 'vue'
import { useDebounceFn, useLocalStorage } from '@vueuse/core'
import Color from 'color'
import AlphaSlider from './alphaSlider.vue'
import Palette from './palette.vue'
import Latest from './latest.vue'
import ColorInput from './colorInput.vue'
import { getHexOpacityColor } from '@/utils/transformColor'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  color: {
    type: String,
    default: ''
  }
},
  emits: ['complete'],
  setup(__props, { emit }) {

const props = __props



const color = ref(props.color)
const alpha = ref<number>(1)

onMounted(() => {
  try {
    const value = Color(props.color)
    alpha.value = value.alpha()
  } catch (error) {
    alpha.value = 1
  }
})

const colorInput = ref<{
  updateInput: (val: string) => void
}>()

const colorHistory = useLocalStorage<string[]>('colorRecord', []) // 最近使用的颜色

const updateColorHistoryFn = useDebounceFn((val: string) => {
  saveRecord(val)
}, 500)

const saveRecord = (val: string) => {
  if (val.trim()) {
    const index = colorHistory.value.indexOf(val)
    if (index === -1) {
      if (colorHistory.value.length === 9) {
        colorHistory.value.splice(8, 1)
      }
      colorHistory.value = [val, ...colorHistory.value]
    } else {
      colorHistory.value.splice(index, 1)
      colorHistory.value = [val, ...colorHistory.value]
    }
  }
}

watch(
  () => props.color,
  val => {
    updateColorHistoryFn(val)
  },
  { immediate: true }
)



const onColorChange = (val: string, alp: number) => {
  color.value = val
  alpha.value = alp
  colorInput.value?.updateInput(val)
  emit('complete', val)
}

const onInputChange = async (input: string) => {
  // 输入为3位自动补全 alpha =1
  let currentColor = ''
  let currentAlpha = alpha.value
  if (input.length === 4) {
    let newInput = ''
    for (const i of input.slice(1, 4)) {
      newInput = newInput + i + i
    }
    currentAlpha = 1
    currentColor = getHexOpacityColor(`#${newInput}`, alpha.value)
  } else if (input.length === 7) {
    currentColor = getHexOpacityColor(input, alpha.value)
  } else if (input.length === 9) {
    const value = Color(input)
    currentAlpha = value.alpha()
    currentColor = input
  }
  await nextTick()
  onColorChange(currentColor, currentAlpha)
}

const handleUpdateAlpha = (val: number) => {
  const newVal = getHexOpacityColor(props.color, val)
  color.value = newVal
  alpha.value = val
  colorInput.value?.updateInput(newVal)
}

const handleCompeteAlpha = () => {
  emit('complete', color.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Palette, { "onUpdate:color": onColorChange }),
    _hoisted_2,
    _createVNode(Latest, {
      historyColor: _unref(colorHistory),
      "onUpdate:color": onColorChange
    }, null, 8, ["historyColor"]),
    _createVNode(AlphaSlider, {
      class: "alpha-slider",
      hex: color.value,
      alpha: alpha.value,
      onUpdateAlpha: handleUpdateAlpha,
      "on-complete": handleCompeteAlpha,
      type: "common"
    }, null, 8, ["hex", "alpha"]),
    _createVNode(ColorInput, {
      class: "color-input",
      color: color.value,
      ref_key: "colorInput",
      ref: colorInput,
      "onUpdate:color": onInputChange
    }, null, 8, ["color"])
  ]))
}
}

})